import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout-oidc',
  imports: [],
  template: ` <p>logout-oidc works!</p> `,
  styles: ``,
})
export class LogoutOidcComponent {
  private router = inject(Router);

  ngOnInit(): void {
    this.handleLogout();
  }
  private async handleLogout(): Promise<void> {
    this.router.navigate(['/']);
  }
}
